/**
 * Pure helpers for the My Feed community sidebar (GROWTH-7130).
 * Behaviour inventory: docs/testing/inventories/feedSidebar.md
 */

/**
 * Rows for the sidebar's specific-community list — "All communities" is rendered separately
 * by the caller, always. When the member follows every community (`communities.all`), there is
 * no specific set to enumerate — GET /api-v2/feed's `new_by_community` is empty in that case too
 * (GROWTH-7128), so an empty list here is the correct, not a fallback, answer.
 *
 * Sort: communities with new items first, then alphabetical within each group (ticket AC).
 *
 * @param {{all: boolean, heritage_ids: number[]}} [communities] state.following.scope.communities
 * @param {Map<number, string>} [titles] heritage_id -> title (helpers/followingView.communityTitles)
 * @param {Object<string, number>} [newByCommunity] GET /api-v2/feed's new_by_community
 * @returns {Array<{id: number, title: string, count: number}>}
 */
export const buildSidebarCommunities = (communities, titles, newByCommunity) => {
  if (!communities || communities.all || !communities.heritage_ids?.length) {
    return [];
  }

  const counts = newByCommunity || {};

  return communities.heritage_ids
    .map(id => ({
      id,
      title: titles?.get(id) || String(id),
      count: Number(counts[id] ?? 0)
    }))
    .sort((a, b) => Number(b.count > 0) - Number(a.count > 0) || a.title.localeCompare(b.title));
};

/**
 * The number beside My Feed's "Following" heading (GROWTH-7216): the specific communities the
 * sidebar lists, or 0 — no number — when the member follows every community.
 *
 * @param {{all: boolean, heritage_ids: number[]}} [communities] state.following.scope.communities
 * @returns {number}
 */
export const countFollowedCommunities = communities => (!communities || communities.all ? 0 : communities.heritage_ids?.length || 0);
